module.exports = __webpack_public_path__ + "img/sequence-suidobashi@2x.18f1946e.jpg";